<template>
  <div id="app">
    <transition name="slide">
        <router-view/>
    </transition>
  </div>
</template>

<script>
    export default {
        watch: {
            '$route' (to, from) {
                const toDepth = to.path.split('/').length
                const fromDepth = from.path.split('/').length
                this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
            }
        }
    }
</script>
